<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the default component for rendering the Duty activity title                                      -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <div v-if="isTrain" class="py-2 DutyActivityTitle_JB">
    <v-row>
      <v-col cols="6">
        <h3>Zug {{ this.dutyActivity.course }} {{ dutyActivity.activityLongname }}</h3>
      </v-col>
      <v-col cols="6" class="d-flex justify-end align-start pt-2 pr-2">
        <v-btn text rounded @click="displayTrainTeam" class="pa-0" style="height: auto">
          Zugteam
          <v-icon class="mr-0 pr-0 pl-1">mdi-account-box-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MODULE_ID from '@/modules/myDuties/moduleId';
import { mapState } from 'vuex';
import commonMixin from '@/mixins/common';

export default {
  name: 'DutyActivityTitle_Default',
  mixins: [commonMixin],

  props: {
    duty: Object,
    dutyActivity: Object,
    config: Object,
    showAllTracksBtn: { type: Boolean, default: false },
    hasTrueChildren: { type: Boolean, default: false },
  },
  components: {},
  data() {
    return {
      selectAllLine: true,
    };
  },
  computed: {
    ...mapState(MODULE_ID, ['teams', 'users', 'usersById']),
    lineNextToBlockcodeTitle() {
      let lineNextToBlockcodeTitle = this.config.showLineNextToBlockcodeTitle;
      return this.dutyActivity.line && lineNextToBlockcodeTitle ? ` / Linie ${this.dutyActivity.line}` : '';
    },
    showTitleJsonHint() {
      return this.config.showTitleJsonHint;
    },
    showActivityTypeIcon() {
      return this.config.showActivityTypeIcon;
    },
    isTrain() {
      return this.dutyActivity.activityShortname.endsWith('zug');
    },
    trainNr() {
      return this.dutyActivity.course;
    },
  },
  methods: {
    onSelect() {
      // console.debug('selectAllLine', this.selectAllLine);
      this.selectAllLine = !this.selectAllLine;
      if (this.selectAllLine) {
        this.$emit('onSelectDutyActivity');
      } else {
        this.$emit('onSelectAllLine');
      }
    },
    displayTrainTeam() {
      let trainNr = this.dutyActivity.course;
      let day = this.dutyActivity.day;
      let trainTeam = this.teams
        .filter((team) => {
          return team.trainNr === trainNr && team.day === day;
        })
        .map((teamMember) => {
          let user = this.usersById[teamMember.idUserFk];
          if (user) {
            Object.assign(teamMember, { firstname: user.firstname, lastname: user.lastname, phone: user.phone });
            return { ...teamMember, id: user.id, firstname: user.firstname, lastname: user.lastname, phone: user.phone };
          }
          return teamMember;
        });
      this.$emit('displayTrainTeam', trainNr, trainTeam);
      return trainTeam;
    },
  },
};
</script>

<style>
h3 {
  line-height: 1;
  font-weight: normal;
}
</style>
